import { render, staticRenderFns } from "./nameInfo.vue?vue&type=template&id=e7bd0736&scoped=true"
import script from "./nameInfo.vue?vue&type=script&lang=js"
export * from "./nameInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bd0736",
  null
  
)

export default component.exports